// src/pages/hire-expert/BlockchainDeveloper.jsx
import React, { useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import "./HireExpert.css";

const BlockchainDeveloper = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Thank you ${formData.name}, we’ll contact you soon!`);
    setFormData({ name: "", email: "", phone: "", message: "" });
  };

  return (
    <>
      <Navbar />

      <div className="hire-expert-container">
        {/* Hero Section */}
        <header className="hero-section">
          <h1>Hire Blockchain Developers</h1>
          <p>
            Build secure, scalable, and innovative blockchain solutions with our
            expert blockchain developers. We specialize in smart contracts,
            decentralized apps (DApps), and enterprise blockchain platforms.
          </p>
          <button
            className="cta"
            onClick={() =>
              document
                .getElementById("contact-form")
                .scrollIntoView({ behavior: "smooth" })
            }
          >
            Book a Call
          </button>
          
        </header>

        {/* Stats Section */}
        <section className="stats">
          <div>
            <h2>32+</h2>
            <p>Countries Served</p>
          </div>
          <div>
            <h2>125+</h2>
            <p>In-house Experts</p>
          </div>
          <div>
            <h2>1870+</h2>
            <p>Projects Delivered</p>
          </div>
          <div>
            <h2>10+</h2>
            <p>Years Experience</p>
          </div>
        </section>

        {/* Tech Stack */}
        <section className="info-section">
          <h2>Technology Stack</h2>
          <ul>
            <li>Ethereum, Hyperledger, Binance Smart Chain, Solana</li>
            <li>Smart Contracts: Solidity, Rust, Go</li>
            <li>Web3.js, Ethers.js, Truffle, Hardhat</li>
            <li>Databases: IPFS, BigchainDB, Firebase, MongoDB</li>
            <li>Cloud & DevOps: AWS, Azure, Docker, Kubernetes</li>
          </ul>
        </section>

        {/* Best Practices */}
        <section className="info-section">
          <h2>Best Practices We Follow</h2>
          <ul>
            <li>Security-first smart contract development</li>
            <li>Decentralized and scalable architecture</li>
            <li>Regular audits and testing</li>
            <li>Gas optimization and performance tuning</li>
            <li>Agile methodology & continuous integration</li>
          </ul>
        </section>

        {/* Services */}
        <section className="info-section">
          <h2>Our Blockchain Development Services</h2>
          <ul className="services-list">
            <li>Smart Contract Development</li>
            <li>Decentralized App (DApp) Development</li>
            <li>Crypto Wallet & Exchange Development</li>
            <li>DeFi & NFT Marketplace Solutions</li>
            <li>Private Blockchain Development</li>
            <li>Tokenization & ICO/IDO Launch</li>
            <li>Blockchain Consulting & Integration</li>
          </ul>
        </section>

        {/* Contact Form */}
        <section id="contact-form" className="contact-section">
          <h2>Book a Call / Contact Us</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Your Phone"
              value={formData.phone}
              onChange={handleChange}
            />
            <textarea
              name="message"
              placeholder="Tell us about your project..."
              value={formData.message}
              onChange={handleChange}
              rows="4"
              required
            ></textarea>
            <button type="submit" className="cta">
              Send Message
            </button>
          </form>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default BlockchainDeveloper;
